import constants from '../constants';
import ChangeDeviceMailRequest from '../Model/changeDeviceMailRequest';
import authAxios from '../authorization/axios';


export const promoteSensor = async (sensorId: number) => {
  const main = constants.api.promoteSensor.replace('{sensorId}', sensorId.toString());

  // TODO: typing the response.
  const response = await authAxios.post(main);

  return response;
};


export const getContact = async (ownerEmail: string) => {
  const main = `${constants.api.getContact}/${ownerEmail}`;

  // TODO: typing the response.
  const response = await authAxios.get(main);

  return response;
};

export const fixPinSensor = async (sensorId: string) => {
  const main = constants.api.fixPin.replace('{sensorId}', sensorId.toString());

  // TODO: typing the response.
  const response = await authAxios.put(main);

  return response;
};


export const moveNftsAlgorandAccount = async (algorandAccount: string) => {
  const main = constants.api.moveNfts.replace('{account}', algorandAccount);

  // TODO: typing the response.
  const response = await authAxios.post(main);

  return response;
};

export const deleteDevice = async (sensorId: string) => {
  const main = constants.api.deleteDeviceOwner.replace('{deviceId}', sensorId.toString());

  // TODO: typing the response.
  const response = await authAxios.post(main);

  return response;
};


export const checkDataSensor = async (sensorId: string) => {
  const main = constants.api.checkData.replace('{deviceId}', sensorId.toString());

  // TODO: typing the response.
  const response = await authAxios.get(main);

  return response;
};


export const banDevice = async (deviceId: string) => {
  const main = constants.api.banDevice.replace('{deviceId}', deviceId.toString());

  // TODO: typing the response.
  const response = await authAxios.post(main);

  return response;
};


export const changeMail = async (sensorId: string, submitData: ChangeDeviceMailRequest) => {
  const main = constants.api.changeMailSensor.replace('{deviceId}', sensorId);

  // TODO: typing the response.
  const response = await authAxios.post(main, submitData);

  return response;
};

export const sensorInfo = async (sensorName: string) => {
  const main = constants.api.sensorDiagnostic.replace(
    ':deviceId',
    encodeURIComponent(sensorName)
  );

  // TODO: typing the response.
  const response = await authAxios.get(main);

  return response;
};

export const getSensorsTestingData = async (type: string, params: any) => {
  const main = constants.api.getSensorsTestingData.replace('{type}', type);

  // TODO: typing the response.
  const response = await authAxios.get(main, { params });

  return response;
};

export const getSensorTestingHistory = async (type: string, sensorId: string) => {
  const main = constants.api.getSensorTestingHistory
    .replace('{type}', type)
    .replace('{id}', sensorId);

  // TODO: typing the response.
  const response = await authAxios.get(main);

  return response;
};

export const getAlgorandAccounts = async () => {
  const main = constants.api.getAlgorandAccounts;

  // TODO: typing the response.
  const response = await authAxios.get(main);

  return response;
};

export const getSensorTypesOnlySensors = async () => {
  const main = constants.api.getSensorTypesOnlySensors;

  // TODO: typing the response.
  const response = await authAxios.get(main);

  return response;
};

export const addSensors = async (data: any) => {
  const main = constants.api.addSensors;

  // TODO: typing the response.
  const response = await authAxios.post(main, data);

  return response;
};

export const importSensors = async (data: any) => {
  const main = constants.api.importSensors;

  // TODO: typing the response.
  const response = await authAxios.post(main, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

  return response;
};